module.exports = __webpack_public_path__ + "static/media/Gotham-Medium.82e60c23.woff2";